import { Component, OnInit, Inject, NgZone } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { PopupComponent } from "src/app/common/components/popup/popup.component";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { ServiceStock } from "../../service-stock.service";
import { InfoPopupComponent } from "src/app/core/components/popup/info-popup/info-popup.component";
import { NativeStorageService } from "src/app/services/mobile/native-storage.service";
import { CustomerService } from "src/app/services/customer.service";

declare var cordova: any;
declare var entrust: any;

@Component({
  selector: "app-tapnpay-tnc-form",
  templateUrl: "./tapnpay-tnc-form.component.html",
  styleUrls: ["./tapnpay-tnc-form.component.scss"],
})
export class TapnpayTncFormComponent implements OnInit {
  checkbocval = false;
  isVisible = false;
  tncForm: FormGroup;
  cardData: any;
  filePath: any;
  pushCounter: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private services: ServiceStock,
    private dialogRef: MatDialogRef<InfoPopupComponent>,
    public popupcomponent: PopupComponent,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialog: MatDialog,
    private _nativeStorage: NativeStorageService,
    private _customerService: CustomerService
  ) {}

  ngOnInit(): void {
    this.tncForm = this.formBuilder.group({
      checkBox: [false],
    });
    this.cardData = this.data.screenData.cardData;
  }

  acceptRegistration() {
    var that = this;
    entrust.checkCardStatus(
      this.data.screenData.cardData.CardRefNO,
      (result: any) => {
        if (result.isCardinWallet == false) {
          that.popupcomponent.closePopup();
           that.pushToNfcWallet(that.data.screenData.cardData.CardRefNO);
        //  that.enrollCard();
        }
      },
      (reason: any) => {
        that.popupcomponent.closePopup();
        that.enrollCard();
      }
    );

    // if(localStorage.getItem("isCardDigital")=="false") {
    //   this.popupcomponent.closePopup();
    //   this.enrollCard();
    // }
    // else if (localStorage.getItem("isCardinWallet")=="false"){
    //   this.popupcomponent.closePopup();
    //   this.pushToNfcWallet(this.cardData.CardRefNO);
    //  // this.pushToNfcWallet("mc4211");
    // }
  }

  enrollCard() {
    var that = this;
    var enrollData = "";
    // var enrollUrl = "https://api.antelop.net/api/v1/digitalCards/prepareDigitization";
    var enrollUrl =
      "https://devapi.creditbank.com.pg/hce/v1/prepareDigitization";
    // var enrollUrl = "https://api.creditbank.com.pg/hce/v1/prepareDigitization";
    var issuerClientId = "";
    // var issuerCardId = "mc4211";
    var issuerCardId = this.cardData.CardRefNO;
    var cardHolderName = "";
    var json = {
      enrollUrl: enrollUrl,
      issuerClientId: issuerClientId,
      issuerCardId: issuerCardId,
      cardHolderName: cardHolderName,
    };
    that.services.showSpinner();
    entrust.enrollCard(json, sCallback, fCallback);
    function sCallback(arg) {
      enrollData = arg;
      console.log(arg);
      // alert("Enrollement Suc data"+enrollData);
      that.services.hideSpinner();
      that.registerNfcCard(that.cardData.CardRefNO, enrollData);
      // that.registerNfcCard("mc4211",enrollData);
    }
    function fCallback(arg) {
      console.log(arg);
      // alert("Enrollement Fail data"+arg);
      that.ngZone.run(() => {
        that.services.hideSpinner();
        that.cardData.txnstatus = "FailureEnd";
        that.router.navigate(["/home", "tapnpayconfirmation"], {
          state: { cardData: that.cardData },
        });
      });
    }
  }

  registerNfcCard(cardId, enrollData) {
    var that = this;
    var json = { cardId: cardId, enrollData: enrollData };
    that.services.showSpinner();
    entrust.digitizeCard(json, sCallback, fCallback);
    function sCallback(arg) {
      setTimeout(() => {
        console.log(arg);
        // alert("digitizeCard Success"+arg);
        that.pushToNfcWallet(cardId);
      }, 3000);
      //that.services.hideSpinner();
    }
    function fCallback(arg) {
      //Card is not digitized.
      console.log(arg);
      //  alert("failure digitization");
      that.ngZone.run(() => {
        that.services.hideSpinner();
        that.cardData.txnstatus = "FailureEnd";
        that.router.navigate(["/home", "tapnpayconfirmation"], {
          state: { cardData: that.cardData },
        });
      });
    }
  }
  pushToNfcWallet(cardId) {
    var that = this;
    // var t =
    //   this._customerService.customerInfo.accountInfo.debitCardDetails.length;

    // console.log("debitCardDetails.length = " + t);
    that.services.showSpinner();

    entrust.pushToNFCWallet(cardId, sCallback, fCallback);
    function sCallback(arg) {
      console.log(arg);
      if (
        that._customerService.customerInfo.accountInfo.debitCardDetails
          .length === 1){
        setTimeout(() => {
        entrust.setNfcCard(cardId, s1Callback, f1Callback);
        function s1Callback(arg) {
          let cd = {
            cdId: cardId,
            tkn: arg.token,
          };
          that._nativeStorage.storeData("default", cd).then((value) => {});

          that.ngZone.run(() => {
            that.services.hideSpinner();
            that.cardData.txnstatus = "DefaultCard";
            that.router.navigate(["/home", "tapnpayconfirmation"], {
              state: { cardData: that.cardData },
            });
          });
        }
        function f1Callback(arg) {}
      }, 3000);
      } else {
        // alert("pushToNFCWallet success"+arg);
        that.ngZone.run(() => {
          that.services.hideSpinner();
          that.cardData.txnstatus = "SuccessEnd";
          that.router.navigate(["/home", "tapnpayconfirmation"], {
            state: { cardData: that.cardData },
          });
        });
      }
    }
    function fCallback(arg) {
      console.log(arg);
      console.log(that.pushCounter);
      that.pushCounter++;
      if (that.pushCounter == 1) {
        setTimeout(() => {
          console.log(arg);
          // alert(arg);
          that.pushToNfcWallet(cardId);
        }, 5000);
      } else {
        that.pushCounter = 0;
        that.services.hideSpinner();
        that.ngZone.run(() => {
          that.cardData.txnstatus = "FailureEnd";
          that.router.navigate(["/home", "tapnpayconfirmation"], {
            state: { cardData: that.cardData },
          });
          // alert("pushToNFCWallet failure"+arg);
        });
      }
    }
  }

  declineRegistration() {
    this.popupcomponent.closePopup();
  }

  onCheckboxChange() {
    if (!this.tncForm.value.checkBox) {
      this.checkbocval = true;
      this.isVisible = true;
    } else {
      this.checkbocval = false;
      this.isVisible = false;
    }
  }

  openTermsCondition() {
    this.filePath = "./assets/images/nfc/TermDeposit.html";
    //for checking in device
    cordova.InAppBrowser.open(this.filePath, "_blank", "location=no");

    //for checking in browser
    //window.open(this.filePath,"_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
  }
}
